export default "__VITE_ASSET__7147ec61__"